import Image, { type ImageProps } from 'next/image'
import { type FC } from 'react'

import { storyblokImageLoader } from '../../config'
import { type StoryblokAssetType } from '../../model/storyblokTypes.generated'

interface StoryblokImageProps
  extends Omit<ImageProps, 'alt' | 'loader' | 'src'> {
  image: StoryblokAssetType
}

export const StoryblokImageComponentHelper: FC<StoryblokImageProps> = ({
  image,
  ...rest
}) =>
  image.filename && (
    <Image
      {...rest}
      alt={image.alt ?? ''}
      loader={storyblokImageLoader}
      src={image.filename}
    />
  )
